/**
 * Summit on a phone (Duncan 2026-10-26: "a message on the mobile website just like facility navigator telling you to
 * download the app"; the mockup he OK'd). Shown INSTEAD of Summit when it's opened on a phone-size touch screen, with
 * "Continue to the web version anyway" remembered until that browser tab closes (FN's Root.tsx / MobileLanding.tsx).
 * Summit's phone app isn't in the stores yet, so for now it says the app is coming soon -- the App Store and Google
 * Play buttons go where that note is once it's published. AFP approval links from emails go straight through (his
 * pick). Decided once, as the page loads: turning the phone or resizing a window never swaps Summit out mid-work.
 */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './phoneLanding.css';

// FN's line (768px wide or less), on a touch screen only: a computer's narrow window keeps Summit.
const PHONE_QUERY = '(max-width: 768px) and (pointer: coarse)';
const KEY = 'summit-force-web';

const PhoneGlyph = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="6" y="2.5" width="12" height="19" rx="2.6" />
    <path d="M9.5 19h5" />
    <circle cx="12" cy="10.5" r="3.6" />
    <path d="M12 8.7v1.8l1.2 1" />
  </svg>
);
const Clock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);

function PhoneLanding({ onContinue }) {
  return (
    <div className="sm-ml">
      <div className="sm-ml-card">
        <div className="sm-ml-brand">
          <img src="/logo.png" alt="" />
          <span>E3 Summit</span>
        </div>
        <div className="sm-ml-glyph"><PhoneGlyph /></div>
        <h1>The Summit app is on the way</h1>
        <p>E3 Summit is built for a computer screen. A Summit app for iPhone and Android is coming soon.</p>
        <div className="sm-ml-soon"><Clock />Coming soon to the App Store and Google Play</div>
        <button type="button" className="sm-ml-web" onClick={onContinue}>Continue to the web version anyway</button>
      </div>
      <div className="sm-ml-foot">E3 Entegral Solutions · E3 Summit</div>
    </div>
  );
}

/** Summit itself, or on a phone the page above first. */
export default function PhoneGate({ children }) {
  const { pathname } = useLocation();
  const [landing, setLanding] = useState(() => {
    if (pathname.startsWith('/afp-routing/')) return false;
    try {
      if (sessionStorage.getItem(KEY) === '1') return false;
    } catch (e) { /* storage blocked: the screen decides */ }
    return !!(window.matchMedia && window.matchMedia(PHONE_QUERY).matches);
  });
  if (!landing) return children;
  return (
    <PhoneLanding onContinue={() => {
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* private mode: on to Summit anyway */ }
      setLanding(false);
    }} />
  );
}
